export default function AboutCard({ text, title,icon }) {
  return (
    <div className="relative bg-white p-8 h-full rounded-xl group transition-all duration-300 cursor-pointer hover:bg-neutral-800 hover:shadow-xl">
      <div className="absolute top-6 left-1/2 transform -translate-x-1/2 text-gray-400 text-[10rem] transition-colors duration-300 group-hover:text-red-600 opacity-20">
        {icon}
      </div>

      <h6 className="uppercase text-center text-2xl text-gray-800 font-extrabold tracking-wide relative z-10 group-hover:text-white ">
        {title}
      </h6>

      <div className="h-0.5 bg-gray-300 mx-auto mt-3 relative z-10 w-full"></div>

      <p className="text-gray-700 text-lg leading-relaxed mt-5 relative z-10 group-hover:text-white font-semibold sm:text-left text-center">
        {text}
      </p>
    </div>
  );
}
